import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDbIcWarning24 = (props) => /* @__PURE__ */ _jsx("svg", {
	id: "icon",
	height: 24,
	viewBox: "0 0 24 24",
	width: 24,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "m11 14.557c0 .623.437 1.115 1 1.115s1.003-.459 1.003-1.115v-4.63c0-.59-.44-1.05-1.003-1.05s-1 .46-1 1.05zm-.69-11.344c.43-.787 1.033-1.213 1.69-1.213s1.3.426 1.721 1.213l8.029 16c.156.328.25.689.25.984 0 .983-.751 1.803-1.847 1.803h-16.306c-1.097 0-1.847-.82-1.847-1.803 0-.328.094-.656.25-.984zm1.945.993c-.105-.137-.191-.206-.255-.206-.096 0-.191.103-.255.206l-7.713 15.313c0 .069-.032.103-.032.206 0 .138.128.275.319.275h15.344c.288 0 .415-.24.288-.48l-7.696-15.315zm-.27 14.614c-.564 0-1.002-.46-1.002-1.05s.438-1.049 1.001-1.049c.564 0 1.002.46 1.002 1.05s-.438 1.049-1.002 1.049z",
		fill: "var(--db-icon-color, currentColor)",
		fillRule: "evenodd"
	})
});
export default SvgDbIcWarning24;
